import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UmsService } from '../ums.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-student-settings-page',
  templateUrl: './student-settings-page.component.html',
  styleUrls: ['./student-settings-page.component.scss']
})
export class StudentSettingsPageComponent implements OnInit, AfterViewInit {
  panelOpenState = false;
  Arr= [
    {name: 'Fax', display: '', Require: true, Visible: true},
    {name: 'Address', display: '', Require: false, Visible: true},
    {name: 'Email', display: '', Require: true, Visible: true},
    
  ];
  value
  isdisabled = false;
  dialogRef: MatDialogRef<any>;
  PersonalDetail : FormArray;
  PersonalDetailTable : []
  ContactDetail: FormArray;
  ContactDetailTable : []
  RegisterDetail : FormArray;
  QualificationDetail : FormArray;
  AdditionalDetail : FormArray;
  PhotoSign : FormArray;
  AdmissionDetail : FormArray;
  Document : FormArray;


  StudentEdit: FormGroup;
  
  ss: any[];
  parentIdList: any;
  filteredparentIdList: any;
  constructor(
    private modalPopupService: ModalpopService,
    public umsService: UmsService,
    private fb: FormBuilder, 
    public router: Router,
    private dialog: MatDialog,private spinner: NgxSpinnerService,
    ) {
      // this.dataSource2.data = TREE_DATA;  
    }
    // hasChild = (_: number, node: FoodNode) => !!node.Arr && node.Arr.length >= 0;
  
  arr1:any = [];
  aar: any = [];
  StudentArr: any = [];
  adminArr: any = [];
  ngOnInit(): void {
    let id = '';
    // this.check = false;
    this.StudentEdit = this.fb.group({
      FormName: new FormControl (''),
      FormRequired: new FormControl (''),
      FormVisible: new FormControl (''),
      FormDisplayName: new FormControl (''),
      FormPattern: new FormControl (''),
      FormControlName: new FormControl (''),
      FormType: new FormControl(''),
      FormPage: new FormControl(''),
      IsDefault: new FormControl(''),
      Module: new FormControl(''),
      ParentID: new FormControl (''),
        PersonalDetail: new FormArray([]),
        ContactDetail: new FormArray([]),
        RegisterDetail: new FormArray([]),
        QualificationDetail : new FormArray([]),
        AdditionalDetail : new FormArray([]),
        PhotoSign : new FormArray([]),
        AdmissionDetail : new FormArray([]),
        Document : new FormArray([]),

    });
    
    // this.getData(id);
  }

  ngAfterViewInit(): void{
    // sessionStorage.clear();
  }

  getPersonalDetailControls(){
    return (this.StudentEdit.get('PersonalDetail') as FormArray).controls;
  }
  getContactDetailControls(){
    return (this.StudentEdit.get('ContactDetail') as FormArray).controls;
  }
  getRegisterDetailControls(){
    return (this.StudentEdit.get('RegisterDetail') as FormArray).controls;
  }
  getQualificationDetailControls(){
    return (this.StudentEdit.get('QualificationDetail') as FormArray).controls;
  }
  getAdditionalDetailControls(){
    return (this.StudentEdit.get('AdditionalDetail') as FormArray).controls;
  }
  getPhotoSignControls(){
    return (this.StudentEdit.get('PhotoSign') as FormArray).controls;
  }
  getAdmissionDetailControls(){
    return (this.StudentEdit.get('AdmissionDetail') as FormArray).controls;
  }
  getDocumentControls(){
    return (this.StudentEdit.get('Document') as FormArray).controls;
  }
  
  getData(id){
    this.getParentData(id);
    const payload = {};
    payload['FormPage'] = id;
      this.umsService.getStdSetting(payload).subscribe(res => {
        this.PersonalDetailTable = res.data
        this.PersonalDetail = this.StudentEdit.get('PersonalDetail') as FormArray;
        this.PersonalDetail.clear();
        this.ContactDetail = this.StudentEdit.get('ContactDetail') as FormArray;
        this.ContactDetail.clear();
        this.RegisterDetail = this.StudentEdit.get('RegisterDetail') as FormArray;
        this.RegisterDetail.clear();
        this.QualificationDetail = this.StudentEdit.get('QualificationDetail') as FormArray;
        this.QualificationDetail.clear();
        this.AdditionalDetail = this.StudentEdit.get('AdditionalDetail') as FormArray;
        this.AdditionalDetail.clear();
        this.PhotoSign = this.StudentEdit.get('PhotoSign') as FormArray;
        this.PhotoSign.clear();
        this.AdmissionDetail = this.StudentEdit.get('AdmissionDetail') as FormArray;
        this.AdmissionDetail.clear();
        this.Document = this.StudentEdit.get('Document') as FormArray;
        this.Document.clear();
        this.PersonalDetailTable.map((element, i) => {
          if(element['FormPage']=='PersonalDetails'){
            this.PersonalDetail = this.StudentEdit.get('PersonalDetail') as FormArray;
            if(element['FormVisible'] === 0 || element['FormVisible'] === false){
              this.value = false;
              this.PersonalDetail.push(this.fb.group({
                FormName: new FormControl (element['FormName']),
                FormRequired: new FormControl ({value: element['FormRequired'], disabled: true}),
                FormVisible: new FormControl (this.value),
                FormDisplayName: new FormControl (element['FormDisplayName']),
                FormPattern: new FormControl (element['FormPattern']),
                FormControlName: new FormControl (element['FormControlName']),
                FormType: new FormControl(element['FormType']),
                FormPage: new FormControl(element['FormPage']),
                ParentID: new FormControl (element['ParentID']),
                IsDefault: new FormControl(element['IsDefault']),
                ID: new FormControl(element['ID']),
                Module: new FormControl('Student'),
                }));
            }else{
              this.PersonalDetail.push(this.fb.group({
                FormName: new FormControl (element['FormName']),
                FormRequired: new FormControl (element['FormRequired']),
                FormVisible: new FormControl (this.value),
                FormDisplayName: new FormControl (element['FormDisplayName']),
                FormPattern: new FormControl (element['FormPattern']),
                FormControlName: new FormControl (element['FormControlName']),
                FormType: new FormControl(element['FormType']),
                FormPage: new FormControl(element['FormPage']),
                ParentID: new FormControl (element['ParentID']),
                IsDefault: new FormControl(element['IsDefault']),
                ID: new FormControl(element['ID']),
                Module: new FormControl('Student'),
                }));
            }
            
          }
          else if(element['FormPage']=='ContactDetails'){
           
            this.ContactDetail = this.StudentEdit.get('ContactDetail') as FormArray;
            if(element['FormVisible'] === 0 || element['FormVisible'] === false){
              this.value = false;
              this.ContactDetail.push(this.fb.group({
                FormName: new FormControl (element['FormName']),
                FormRequired: new FormControl ({value: element['FormRequired'], disabled: true}),
                FormVisible: new FormControl (this.value),
                FormDisplayName: new FormControl (element['FormDisplayName']),
                FormPattern: new FormControl (element['FormPattern']),
                FormControlName: new FormControl (element['FormControlName']),
                FormType: new FormControl(element['FormType']),
                FormPage: new FormControl(element['FormPage']),
                ParentID: new FormControl (element['ParentID']),
                IsDefault: new FormControl(element['IsDefault']),
                ID: new FormControl(element['ID']),
                Module: new FormControl('Student'),
                }));
            }else{
              if(element['FormVisible'] === 1 || element['FormVisible'] === true){
                this.value = true;
              }
              this.ContactDetail.push(this.fb.group({
                FormName: new FormControl (element['FormName']),
                FormRequired: new FormControl (element['FormRequired']),
                FormVisible: new FormControl (this.value),
                FormDisplayName: new FormControl (element['FormDisplayName']),
                FormPattern: new FormControl (element['FormPattern']),
                FormControlName: new FormControl (element['FormControlName']),
                FormType: new FormControl(element['FormType']),
                FormPage: new FormControl(element['FormPage']),
                ParentID: new FormControl (element['ParentID']),
                IsDefault: new FormControl(element['IsDefault']),
                ID: new FormControl(element['ID']),
                Module: new FormControl('Student'),
                }));
            }
           
          }
          else if(element['FormPage']=='ReserveDetails'){
           
            this.RegisterDetail = this.StudentEdit.get('RegisterDetail') as FormArray;
            if(element['FormVisible'] === 0 || element['FormVisible'] === false){
              this.value = false;
              this.RegisterDetail.push(this.fb.group({
                FormName: new FormControl (element['FormName']),
                FormRequired: new FormControl ({value: element['FormRequired'], disabled: true}),
                FormVisible: new FormControl (this.value),
                FormDisplayName: new FormControl (element['FormDisplayName']),
                FormPattern: new FormControl (element['FormPattern']),
                FormControlName: new FormControl (element['FormControlName']),
                FormType: new FormControl(element['FormType']),
                FormPage: new FormControl(element['FormPage']),
                ParentID: new FormControl (element['ParentID']),
                IsDefault: new FormControl(element['IsDefault']),
                ID: new FormControl(element['ID']),
                Module: new FormControl('Student'),
                }));
            }else{
              if(element['FormVisible'] === 1 || element['FormVisible'] === true){
                this.value = true;
              }
              this.RegisterDetail.push(this.fb.group({
                FormName: new FormControl (element['FormName']),
                FormRequired: new FormControl (element['FormRequired']),
                FormVisible: new FormControl (this.value),
                FormDisplayName: new FormControl (element['FormDisplayName']),
                FormPattern: new FormControl (element['FormPattern']),
                FormControlName: new FormControl (element['FormControlName']),
                FormType: new FormControl(element['FormType']),
                FormPage: new FormControl(element['FormPage']),
                ParentID: new FormControl (element['ParentID']),
                IsDefault: new FormControl(element['IsDefault']),
                ID: new FormControl(element['ID']),
                Module: new FormControl('Student'),
                }));
            }
          
          }
          else if(element['FormPage']=='QualifyDetails'){
           
            this.QualificationDetail = this.StudentEdit.get('QualificationDetail') as FormArray;
            if(element['FormVisible'] === 0 || element['FormVisible'] === false){
              this.value = false;
              this.QualificationDetail.push(this.fb.group({
                FormName: new FormControl (element['FormName']),
                FormRequired: new FormControl ({value: element['FormRequired'], disabled: true}),
                FormVisible: new FormControl (this.value),
                FormDisplayName: new FormControl (element['FormDisplayName']),
                FormPattern: new FormControl (element['FormPattern']),
                FormControlName: new FormControl (element['FormControlName']),
                FormType: new FormControl(element['FormType']),
                FormPage: new FormControl(element['FormPage']),
                ParentID: new FormControl (element['ParentID']),
                IsDefault: new FormControl(element['IsDefault']),
                ID: new FormControl(element['ID']),
                Module: new FormControl('Student'),
                }));
            }else{
              if(element['FormVisible'] === 1 || element['FormVisible'] === true){
                this.value = true;
              }
              this.QualificationDetail.push(this.fb.group({
                FormName: new FormControl (element['FormName']),
                FormRequired: new FormControl (element['FormRequired']),
                FormVisible: new FormControl (this.value),
                FormDisplayName: new FormControl (element['FormDisplayName']),
                FormPattern: new FormControl (element['FormPattern']),
                FormControlName: new FormControl (element['FormControlName']),
                FormType: new FormControl(element['FormType']),
                FormPage: new FormControl(element['FormPage']),
                ParentID: new FormControl (element['ParentID']),
                IsDefault: new FormControl(element['IsDefault']),
                ID: new FormControl(element['ID']),
                Module: new FormControl('Student'),
                }));
            }
            
          }
          else if(element['FormPage']=='AdditionalDetail'){
        
            this.AdditionalDetail = this.StudentEdit.get('AdditionalDetail') as FormArray;
            if(element['FormVisible'] === 0 || element['FormVisible'] === false){
              this.value= false;
              this.AdditionalDetail.push(this.fb.group({
                FormName: new FormControl (element['FormName']),
                FormRequired: new FormControl ({value: element['FormRequired'], disabled: true}),
                FormVisible: new FormControl (this.value),
                FormDisplayName: new FormControl (element['FormDisplayName']),
                FormPattern: new FormControl (element['FormPattern']),
                FormControlName: new FormControl (element['FormControlName']),
                FormType: new FormControl(element['FormType']),
                FormPage: new FormControl(element['FormPage']),
                ParentID: new FormControl (element['ParentID']),
                IsDefault: new FormControl(element['IsDefault']),
                ID: new FormControl(element['ID']),
                Module: new FormControl('Student'),
                }));
            }else{
              if(element['FormVisible'] === 1 || element['FormVisible'] === true){
                this.value = true;
              }
              this.AdditionalDetail.push(this.fb.group({
                FormName: new FormControl (element['FormName']),
                FormRequired: new FormControl (element['FormRequired']),
                FormVisible: new FormControl (this.value),
                FormDisplayName: new FormControl (element['FormDisplayName']),
                FormPattern: new FormControl (element['FormPattern']),
                FormControlName: new FormControl (element['FormControlName']),
                FormType: new FormControl(element['FormType']),
                FormPage: new FormControl(element['FormPage']),
                ParentID: new FormControl (element['ParentID']),
                IsDefault: new FormControl(element['IsDefault']),
                ID: new FormControl(element['ID']),
                Module: new FormControl('Student'),
                }));
            }
           
          }
          else if(element['FormPage']=='PhotoSign'){
           
            this.PhotoSign = this.StudentEdit.get('PhotoSign') as FormArray;
            if(element['FormVisible'] === 0 || element['FormVisible'] === false){
              this.value =false;
              this.PhotoSign.push(this.fb.group({
                FormName: new FormControl (element['FormName']),
                FormRequired: new FormControl ({value: element['FormRequired'], disabled: true}),
                FormVisible: new FormControl (this.value),
                FormDisplayName: new FormControl (element['FormDisplayName']),
                FormPattern: new FormControl (element['FormPattern']),
                FormControlName: new FormControl (element['FormControlName']),
                FormType: new FormControl(element['FormType']),
                FormPage: new FormControl(element['FormPage']),
                ParentID: new FormControl (element['ParentID']),
                IsDefault: new FormControl(element['IsDefault']),
                ID: new FormControl(element['ID']),
                Module: new FormControl('Student'),
                }));
            }else{
              if(element['FormVisible'] === 1 || element['FormVisible'] === true){
                this.value = true;
              }
              this.PhotoSign.push(this.fb.group({
                FormName: new FormControl (element['FormName']),
                FormRequired: new FormControl (element['FormRequired']),
                FormVisible: new FormControl (this.value),
                FormDisplayName: new FormControl (element['FormDisplayName']),
                FormPattern: new FormControl (element['FormPattern']),
                FormControlName: new FormControl (element['FormControlName']),
                FormType: new FormControl(element['FormType']),
                FormPage: new FormControl(element['FormPage']),
                ParentID: new FormControl (element['ParentID']),
                IsDefault: new FormControl(element['IsDefault']),
                ID: new FormControl(element['ID']),
                Module: new FormControl('Student'),
                }));
            }
            
          }
          else if(element['FormPage']=='AdmDetails'){
           
            this.AdmissionDetail = this.StudentEdit.get('AdmissionDetail') as FormArray;
            if(element['FormVisible'] === 0 || element['FormVisible'] === false){
              this.value= false;
              this.AdmissionDetail.push(this.fb.group({
                FormName: new FormControl (element['FormName']),
                FormRequired: new FormControl ({value: element['FormRequired'], disabled: true}),
                FormVisible: new FormControl (this.value),
                FormDisplayName: new FormControl (element['FormDisplayName']),
                FormPattern: new FormControl (element['FormPattern']),
                FormControlName: new FormControl (element['FormControlName']),
                FormType: new FormControl(element['FormType']),
                FormPage: new FormControl(element['FormPage']),
                ParentID: new FormControl (element['ParentID']),
                IsDefault: new FormControl(element['IsDefault']),
                ID: new FormControl(element['ID']),
                Module: new FormControl('Student'),
                }));
            }else{
              if(element['FormVisible'] === 1 || element['FormVisible'] === true){
                this.value = true;
              }
              this.AdmissionDetail.push(this.fb.group({
                FormName: new FormControl (element['FormName']),
                FormRequired: new FormControl (element['FormRequired']),
                FormVisible: new FormControl (this.value),
                FormDisplayName: new FormControl (element['FormDisplayName']),
                FormPattern: new FormControl (element['FormPattern']),
                FormControlName: new FormControl (element['FormControlName']),
                FormType: new FormControl(element['FormType']),
                FormPage: new FormControl(element['FormPage']),
                ParentID: new FormControl (element['ParentID']),
                IsDefault: new FormControl(element['IsDefault']),
                ID: new FormControl(element['ID']),
                Module: new FormControl('Student'),
                }));
            }
           
          }
          else if(element['FormPage']=='Documents'){
           
            this.Document = this.StudentEdit.get('Document') as FormArray;
            if(element['FormVisible'] == false){
              this.Document.push(this.fb.group({
                FormName: new FormControl (element['FormName']),
                FormRequired: new FormControl ({value: element['FormRequired'], disabled: true}),
                FormVisible: new FormControl (element['FormVisible']),
                FormDisplayName: new FormControl (element['FormDisplayName']),
                FormPattern: new FormControl (element['FormPattern']),
                FormControlName: new FormControl (element['FormControlName']),
                FormType: new FormControl(element['FormType']),
                FormPage: new FormControl(element['FormPage']),
                ParentID: new FormControl (element['ParentID']),
                IsDefault: new FormControl(element['IsDefault']),
                ID: new FormControl(element['ID']),
                Module: new FormControl('Student'),
                }));
            }else{
              this.Document.push(this.fb.group({
                FormName: new FormControl (element['FormName']),
                FormRequired: new FormControl (element['FormRequired']),
                FormVisible: new FormControl (element['FormVisible']),
                FormDisplayName: new FormControl (element['FormDisplayName']),
                FormPattern: new FormControl (element['FormPattern']),
                FormControlName: new FormControl (element['FormControlName']),
                FormType: new FormControl(element['FormType']),
                FormPage: new FormControl(element['FormPage']),
                ParentID: new FormControl (element['ParentID']),
                IsDefault: new FormControl(element['IsDefault']),
                ID: new FormControl(element['ID']),
                Module: new FormControl('Student'),
                }));
            }
            
          }
          
        });
      });
   
  }


  redirect(to: string): void {
    this.router.navigate([to]);
  }

  next(){
    this.redirect('student-form');
  }
  Regnext(){
    this.redirect('student-registration-tab');
  }

  updateDetails(e){
    this.spinner.show();
    this.umsService.updateStdSetting(e.getRawValue()).subscribe(res => {
      this.spinner.hide();
  const  data = {};
  data['message'] = res.message;
  data['title'] = 'Information';
  data['icon'] = 'fas fa-check';
  this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  visableChange(i,value,page){
    // if(i == 1)
  if(value.FormVisible == false){
    let taskListArrays = this.StudentEdit.get(page) as FormArray;
    if(taskListArrays.controls[i].value.FormVisible == false){
      taskListArrays.controls[i].patchValue({"FormRequired":false}); 
      taskListArrays.controls[i].get('FormRequired').disable();
      taskListArrays.controls[i].patchValue({"FormRequired":false}); 
    }
  }else if (value.FormVisible == true){
    let taskListArrays = this.StudentEdit.get(page) as FormArray;
    if(taskListArrays.controls[i].value.FormVisible == true){
      taskListArrays.controls[i].get('FormRequired').enable();
    }
  }
  }
  // save(){
  //   this.update();
  // }


  getParentData(pageName){
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = pageName
    this.umsService.getParentId(payload).subscribe(res => {
      this.spinner.hide();
      this.parentIdList = res.data;
      this.filteredparentIdList = this.parentIdList.slice();
    });
  }
}